export function sleep(t) {
    return new Promise((resolve) => setTimeout(resolve, t));
}
export function isIOS() {
    return /(iPhone|iPad|iPod)/i.test(window.navigator.userAgent);
}
export function getWebInitTimestamp() {
    var _a;
    // eslint-disable-next-line @ttfe/@typescript-eslint/no-unnecessary-condition
    return ((_a = performance === null || performance === void 0 ? void 0 : performance.timing) === null || _a === void 0 ? void 0 : _a.navigationStart) || (performance === null || performance === void 0 ? void 0 : performance.timeOrigin);
}
function isPerformanceNavigationTiming(t) {
    return (t.responseStart > 0 &&
        t.responseStart < window.performance.now());
}
export function getPerformanceNavigationTiming() {
    const navigationEntry = window.performance && window.performance.getEntriesByType && window.performance.getEntriesByType('navigation')[0];
    if (navigationEntry && isPerformanceNavigationTiming(navigationEntry)) {
        return navigationEntry;
    }
    return;
}
export class Deferred {
    constructor() {
        this.isResolved = false;
        this.promise = new Promise((resolve) => {
            this._resolve = resolve;
        });
    }
    resolve(value) {
        if (!this.isResolved) {
            this._resolve(value);
            this.resolvedValue = value;
            this.isResolved = true;
        }
    }
    reset() {
        this.resolvedValue = undefined;
        this.isResolved = false;
        this.promise = new Promise((resolve) => {
            this._resolve = resolve;
        });
    }
}
export function isPerformanceAPISupported() {
    var _a, _b, _c;
    return !!(((_a = window.performance) === null || _a === void 0 ? void 0 : _a.now) &&
        ((_b = window.performance) === null || _b === void 0 ? void 0 : _b.mark) &&
        ((_c = window.performance) === null || _c === void 0 ? void 0 : _c.measure));
}
export function getVmokGlobalProps(name, key) {
    var _a, _b;
    if (typeof window !== 'undefined') {
        return ((_b = (_a = window.__VOM_GLOBAL_TIMING_STORE_KEY) === null || _a === void 0 ? void 0 : _a[name]) === null || _b === void 0 ? void 0 : _b[key]) || 0;
    }
    return 0;
}
//# sourceMappingURL=util.js.map